import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { LoaderService, MessagesComponent } from '@shared/components';
import { LanguageService } from './i18n';
import { AccountLoadersService } from './core/libraries';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [RouterOutlet, MessagesComponent],
    providers: [AccountLoadersService],
})
export class AppComponent implements OnInit {
    readonly loaderService = inject(LoaderService);
    readonly languageService = inject(LanguageService);
    readonly accountLoadersService = inject(AccountLoadersService);

    ngOnInit(): void {
        this.languageService.init();
        this.accountLoadersService.init();
    }
}
